import es from "../content/es.js";
import { whatsappTo } from "../shared/links.js";
import { HERO_SLIDES, type V2Content } from "./content.js";

const content: V2Content = {
  ...es,
  meta: {
    ...es.meta,
    title: "Kuori — el evento entero, por quienes estuvieron allí",
  },
  nav: { ...es.nav, short: "Empezar ahora" },
  menu: {
    product: "Producto",
    explore: "Explora Kuori",
    items: [
      {
        href: "#como",
        icon: "qr",
        title: "Cómo funciona",
        body: "Del QR a la pantalla, en segundos.",
      },
      {
        href: "#produto",
        icon: "monitor",
        title: "La pantalla",
        body: "Revela al momento o al final. Oculta desde el celular.",
      },
      {
        href: "#album",
        icon: "images",
        title: "El álbum",
        body: "Listo al día siguiente, hora por hora.",
      },
      {
        href: "#marca",
        icon: "palette",
        title: "Marca blanca",
        body: "Tu nombre y tu color en la invitación y en la pantalla.",
      },
    ],
    links: [
      {
        href: whatsappTo("¡Hola! Quiero un presupuesto de Kuori para mi evento."),
        icon: "whatsapp",
        title: "Get a quote",
        external: true,
      },
      { href: "#faq", icon: "help", title: "Preguntas" },
    ],
    start: "Empezar ahora",
    startHref: whatsappTo("¡Hola! Quiero empezar a usar Kuori."),
    talk: "Habla con Kuori",
  },
  hero: {
    ...es.hero,
    sub: "El invitado apunta la cámara al QR, fotografía desde el navegador y la foto llega al álbum y a la pantalla en segundos. Sin instalar nada.",
    alt: "Ver cómo funciona",
    slides: HERO_SLIDES,
  },
  live: {
    label: "Pantalla · ejemplo",
    event: "Boda de Leo y Day",
    live: "en vivo",
    count: "fotos en el álbum",
    sent: "envió una foto",
    minutes: "hace {n} min",
    join: "Apunta la cámara al QR",
  },
  numbers: [
    { value: 0, label: "aplicaciones que el invitado tenga que instalar" },
    { value: 1, label: "QR para todo el evento, de la invitación a la pantalla" },
    { value: 60, unit: "s", label: "para crear el evento e imprimir el QR" },
  ],
  flow: {
    label: "Cómo funciona",
    title: "Del QR a la pantalla, en segundos.",
    steps: [
      {
        tag: "Apunta",
        title: "El QR abre el evento.",
        body: "Va en la invitación, en la tarjeta de mesa y en la pantalla. La cámara del celular lo reconoce y abre el evento en el navegador.",
      },
      {
        tag: "Entra",
        title: "Nombre y apellido. Nada más.",
        body: "Sin registro, sin contraseña y sin aplicación. Funciona incluso desde dentro de WhatsApp e Instagram.",
      },
      {
        tag: "Fotografía",
        title: "La cámara del evento, al instante.",
        body: "Cada invitado tiene su cupo de fotos. La foto sale en calidad original, sin la compresión de los grupos.",
      },
      {
        tag: "En pantalla",
        title: "Y todos la ven.",
        body: "La foto entra en el álbum y aparece en la pantalla con el nombre de quien la tomó, mientras el evento sucede.",
      },
    ],
    scan: "Boda de Leo y Day",
    open: "Abrir en el navegador",
    invitedBy: "Invitado por",
    headline: ["Las fotos del evento, ", "por ti"],
    first: "Nombre",
    last: "Apellido",
    guest: ["Ana", "Souza"],
    enter: "Entrar al evento",
    noApp: "Sin instalar aplicaciones.",
    left: "8 de 10 fotos",
    sentToWall: "Enviada. Ya está en la pantalla.",
    hint: "Desplázate para seguir",
    nudge: "Desliza para ver el siguiente paso",
    nudgeLast: "Sigue desplazándote",
    scrollNext: "Desplázate al siguiente paso",
    scrollCue: "Desplázate",
    next: "Siguiente",
    stepOf: "{n} de {total}",
  },
  wall: {
    live: "en vivo",
    count: "Fotos en el álbum",
    now: "Ahora mismo",
    join: "Entra al álbum y envía tu foto",
    point: "apunta la cámara",
    madeWith: "hecho con",
    waiting: "Las fotos aparecen a las 23 h",
    kept: "fotos guardadas para la revelación",
    label:
      "Ilustración de la pantalla: la foto más reciente destacada, las anteriores al lado y el QR del evento",
  },
  control: {
    label: "El día del evento",
    title: "La pantalla te obedece.",
    body: "Revela las fotos al momento o solo al final. Oculta una foto en segundos desde el celular y sale de la pantalla al instante. Pruébalo aquí.",
    reveal: "Revelación",
    revealNow: "Al momento",
    revealEnd: "Al final",
    revealNowHint: "Cada foto aparece en la pantalla en cuanto llega.",
    revealEndHint: "Las fotos quedan guardadas y aparecen juntas al final.",
    recent: "Fotos recientes",
    hide: "Ocultar",
    show: "Mostrar",
    hidden: "Oculta",
    hideLabel: "Ocultar la foto de {name}",
    showLabel: "Mostrar la foto de {name}",
    event: "Boda de Leo y Day",
  },
  album: {
    label: "Después",
    title: "El álbum listo, hora por hora.",
    body: "Al día siguiente, cada foto está en el álbum, separada por la hora en que se tomó y en calidad original. Toca una hora.",
    all: "Todo",
    photos: "fotos",
    original: "Calidad original",
  },
  studio: {
    label: "Marca blanca",
    title: "Tu nombre al frente. El nuestro, fuera del camino.",
    body: "Los profesionales de eventos entregan Kuori con su propio nombre y su propio color, en la invitación y en la pantalla. Cámbialos abajo y mira.",
    names: ["Atelier Marília", "Studio Aurora", "Casa Lume"],
    nameLabel: "Nombre",
    colorLabel: "Color",
    colorNames: { pink: "Rosa", blue: "Azul", green: "Verde", amber: "Ámbar", ink: "Negro" },
    demo: {
      cta: "Probar la demo (en portugués)",
      note: "La demo completa empieza con el nombre y el color que elegiste. Unos dos minutos, sin registro.",
      qrTitle: "¿Prefieres en el celular?",
      qrBody: "Apunta la cámara aquí para abrir la demo.",
    },
  },
  ending: {
    title: "¿Fotografiamos tu próximo evento?",
    note: "Respondemos el mismo día hábil.",
    action: "Hablar por WhatsApp",
    rights: "2026 Kuori",
  },
};

export default content;
